import { cmDate } from '../../../pages/Delivery/Deliverables/lib/format';
function present(v) {
    const s = (v ?? '').trim();
    return s !== '' && s !== '—';
}
/**
 * Which optional columns the card shows: a column every row leaves empty is
 * dropped, so a document upload has no Deliverable or Team column and a risk
 * has no Date column. Team shows only when some row names a team.
 */ export function visibleOptionalColumns(rows) {
    const out = new Set();
    for (const r of rows){
        if (present(r.destination)) out.add('destination');
        if (present(r.deliverable)) out.add('deliverable');
        if (present(r.dueOn)) out.add('date');
        if (present(r.team)) out.add('team');
        if (present(r.fileNames)) out.add('files');
        if (present(r.before)) out.add('before');
    }
    return out;
}
// A day on its own, not part of a file name or a link ("msr-2026-03-05.pdf").
const ISO_DAY = /(?<![\w./-])(\d{4}-\d{2}-\d{2})(?![\w/-]|\.\w)/g;
/** Card cell text with ISO days ("2026-03-05") written as "5 Mar 2026". */ export function cardText(s) {
    if (!s) return '';
    return s.replace(ISO_DAY, (day)=>cmDate(day, day));
}
